export const convertValueIntoTime = (value: number): string => {
  let result = value === 1 ? `${value} hour` : `${value} hrs`;

  const roundTenth = (val: number) => {
    let resultValue = val;
    if (val && val.toString().includes('.')) {
      const daysInteger = val.toString().split('.')[0];
      const daysTenth = val.toString().split('.')[1].slice(0, 1);
      if (+daysTenth >= 5) {
        resultValue = +`${daysInteger}.5`;
      } else resultValue = +daysInteger;
    }
    return resultValue;
  };

  if (value.toString().split('.').length > 1) {
    const slicedHours = value.toString().split('.')[0];
    const slicedMins = value.toString().split('.')[1].slice(0, 2);

    const formatMinutes = () => {
      let resultInMins = '0';
      if (slicedMins !== '00') {
        const mins = ((+slicedMins * 60) / 100).toFixed(0);
        if (+mins < 10) {
          resultInMins = `0${mins}`;
        } else {
          resultInMins = mins;
        }
      }
      return resultInMins;
    };

    const singleMinutes =
      slicedMins !== '00' ? +((+slicedMins * 60) / 100).toFixed(0) : 0;
    const minutesValueWithHours = formatMinutes();
    const hours = +slicedHours;
    const days = hours >= 24 ? hours / 24 : 0;
    const weeks = days >= 7 ? days / 7 : 0;
    const months = days >= 30 ? days / 30 : 0;

    const isLessThenMinuteCheck = hours === 0 && singleMinutes === 0;

    const isLessThenHourCheck = hours === 0 && singleMinutes > 0;

    const isBetweenOneHourAndThreeDays = hours >= 1 && hours < 72;

    const isBetweenThreeAndTenDays = days >= 3 && days < 10;

    const isBetweenTenAndThirtyDays = days >= 10 && days < 30;

    const isBetweenThirtyAndEightyFourDays = days >= 30 && days < 84;

    const isMoreThenEightyFourDays = days >= 84;

    if (isLessThenMinuteCheck) {
      result = `< 1 min`;
    } else if (isLessThenHourCheck) {
      result =
        singleMinutes === 1 ? `${singleMinutes} min` : `${singleMinutes} mins`;
    } else if (isBetweenOneHourAndThreeDays) {
      if (singleMinutes > 0) {
        result = `${slicedHours}:${minutesValueWithHours} hrs`;
      } else if (singleMinutes === 0) {
        result =
          +slicedHours === 1 ? `${slicedHours} hour` : `${slicedHours} hrs`;
      }
    } else if (isBetweenThreeAndTenDays) {
      result = `${roundTenth(days)} days`;
    } else if (isBetweenTenAndThirtyDays) {
      result = `${Math.floor(days)} days`;
    } else if (isBetweenThirtyAndEightyFourDays) {
      result = `${roundTenth(weeks)} weeks`;
    } else if (isMoreThenEightyFourDays) {
      result = `${roundTenth(months)} months`;
    }
  } else {
    const days = value >= 24 ? value / 24 : 0;
    const weeks = days >= 7 ? days / 7 : 0;
    const months = days >= 30 ? days / 30 : 0;

    const isBetweenThreeAndTenDays = days >= 3 && days < 10;
    const isBetweenTenAndThirtyDays = days >= 10 && days < 30;
    const isBetweenThirtyAndEightyFourDays = days >= 30 && days < 84;
    const isMoreThenEightyFourDays = days >= 84;

    if (isBetweenThreeAndTenDays) {
      result = `${roundTenth(days)} days`;
    } else if (isBetweenTenAndThirtyDays) {
      result = `${Math.floor(days)} days`;
    } else if (isBetweenThirtyAndEightyFourDays) {
      result = `${roundTenth(weeks)} weeks`;
    } else if (isMoreThenEightyFourDays) {
      result = `${roundTenth(months)} months`;
    }
  }

  return result;
};
